<template>
  <div class="my-layout-box p-order" style="background-color:#f2f2f2">
    <!-- <van-tabs v-model="active" @change="changeTab">
      <van-tab v-for="(item, index) in tabList" :key="index" :title="item.title"></van-tab>
    </van-tabs> -->
    <van-cell class="item-title" title="产品信息" required>
    </van-cell>
    <div style="padding:10px 5px;min-height:140px;background-color:#fff">
      <div style="display:flex;justify-content: flex-end;">
        <!-- <van-button type="primary" style="background-color:#EE7700;border:none;padding:5px;margin-left:10px" size="small">Excel导入</van-button> -->
        <van-button type="primary" style="background-color:#EE7700;border:none;padding:5px;margin-left:10px" size="small" @click="showPaste=true">粘贴导入</van-button>
        <van-button type="primary" style="background-color:#EE7700;border:none;padding:5px;margin-left:10px" size="small" @click="show=true">新增</van-button>
      </div>
      <div style="margin-top:10px;border:1px solid #ccc;width:100%;padding:10px 6px;position:relative" v-for="(v,i) in orderInfo.LineList" :key="i">
        <div>
          <span style="background-color:#999;height:10px;padding:0 4px;margin-right:5px;color:#fff">{{i+1}}</span>
          <span>{{v.PartNo}} </span>
          <span>/ {{v.Brand}} </span>
          <span>/ {{v.Quantity}} {{v.Unit}}</span>
        </div>
        <div style="margin-top:5px">
          <span style="margin-left:20px">单价：{{v.UnitPrice}} </span>
          <span style="margin-left:20px">总价：{{v.Amount}} </span>
        </div>
        <div style="position: absolute;right:10px;display:flex;top:32px">
          <span style="color:#1989fa" @click="editProdctItem(i)">编辑</span>
          <span style="color:#ee0a24;margin-left:20px" @click="delProductItem(i)">删除</span>
        </div>
      </div>
      <van-empty class="custom-image" description="暂无商品信息" v-if="orderInfo.LineList.length==0" />
      <div style="display:flex;margin-top:10px;justify-content: space-around;">
        <div>条数：{{orderInfo.LineList.length}}</div>
        <div>币别：{{orderInfo.CurrencyType}}</div>
        <div style="text-align:right">
          <span>总价：{{TotalAmount}} </span>
          <!-- <span style="margin-left:10px">总净重：0 KG</span>
          <span style="margin-left:10px">总毛重：0 KG</span> -->
        </div>
      </div>
    </div>

    <van-popup v-model="show" :overlay="false" position="top" :style="{ height: '100%','background-color':'#f2f2f2' }" :lock-scroll="true">
      <van-form @submit="saveCurLineDetail" ref="lineDetailForm">
        <div>
          <van-notice-bar left-icon="warning-o" text="请如实填报产品信息，以避免不必要的法律责任" style="height:25px" />
          <van-field v-model="lineDetail.ProductName" label="品名" placeholder="请输入品名" />
          <van-field required v-model="lineDetail.PartNo" label="型号" placeholder="请输入型号" :rules="[{ required: true, message: '请输入型号' }]" />
          <van-field required v-model="lineDetail.Brand" label="品牌" placeholder="请输入品牌" :rules="[{ required: true, message: '请输入品牌' }]" />
          <van-field required v-model="lineDetail.Unit" label="单位" placeholder="请输入单位" :rules="[{ required: true, message: '请输入单位' }]" />
          <van-field required v-model="lineDetail.Quantity" type="number" label="数量" placeholder="请输入数量" :rules="[{ required: true, message: '请输入数量' }]" />
          <van-field required readonly name="picker" :value="orderInfo.CurrencyType" label="币种" placeholder="点击选择币种" @click="currencyTypeSel = true" right-icon="arrow-down" />
          <van-popup v-model="currencyTypeSel" position="bottom">
            <van-picker show-toolbar :columns="currencyTypeList" @confirm="selcurrencyType" @cancel="currencyTypeSel = false" />
          </van-popup>
          <van-field required v-model="lineDetail.UnitPrice" type="number" @input="unitPriceChange" label="单价" placeholder="请输入单价" :rules="[{ required: true, message: '请输入单价' }]" />
          <van-field required v-model="lineDetail.Amount" type="number" @input="amountChange" label="总价" placeholder="请输入总价（系统自动计算）" :rules="[{ required: true, message: '请输入总价' }]" />
          <van-field :required="orderInfo.DealType==8" v-model="lineDetail.ErpOriginRegion" label="产地（中文）" placeholder="请输入产地" :rules="orderInfo.DealType == 8 ? [{ required: true, message: '请输入产地' }]:[]" />
        </div>
        <div style="display:flex;justify-content: space-between;margin-top:40px;padding:0 20px">
          <van-button type="default" size="normal" style="width:40%" native-type="button" @click="hideLineDetailEdit()">取消</van-button>
          <van-button type="info" size="normal" native-type="submit" style="width:40%;background-color:#EE7700;border:none;padding:5px">确定</van-button>
        </div>
      </van-form>
    </van-popup>

    <van-popup v-model="showPaste" :overlay="false" position="top" :style="{ height: '100%','background-color':'#f2f2f2' }" :lock-scroll="true">
      <van-notice-bar left-icon="warning-o" text="请如实填报产品信息，以避免不必要的法律责任" style="height:25px" />
      <div style="margin:8px">
        <van-field v-model="pasteText" style="padding:0px" rows="12" autosize type="textarea" placeholder="示例：
NXP牌，FX32K146UATOVLHT，荷兰，120，个，12.34
TI牌，LM358，墨西哥，200，个，5.6789" />

        <div style="margin-top:20px">
          导入说明：<br />
          请在上方输入框依次输入【品名<span style="color:red">品牌</span>，<span style="color:red">型号</span>，<span style="color:red">产地</span>，<span style="color:red">数量</span>，<span style="color:red">单位</span>，<span style="color:red">单价</span>，净重，毛重，料号，编号】，红字部分为必填项。
        </div>
      </div>
      <div style="display:flex;justify-content: space-between;margin-top:40px;padding:0 20px">
        <van-button type="default" size="normal" style="width:40%" @click="showPaste=false">取消</van-button>
        <van-button type="info" size="normal" @click="pasteProductInfo" style="width:40%;background-color:#EE7700;border:none;padding:5px">确定</van-button>
      </div>
    </van-popup>

    <van-divider :style="{ padding: '0',height: '6px',margin: '0','border-width': '3px'}" />

    <van-form @submit="saveOrder" ref="importOrder">

      <van-field readonly clickable name="picker" :value="reservedName" label="预留单号" placeholder="" @click="reservedSel = true" right-icon="arrow-down" />
      <van-popup v-model="reservedSel" position="bottom">
        <van-picker value-key="OrderNo" show-toolbar :columns="reservedList" @confirm="selReserved" @cancel="reservedSel = false" />
      </van-popup>

      <van-field required readonly clickable name="picker" :value="dealTypeName" label="报关方式" placeholder="点击选择报关方式" @click="showDealTypeSel = true" right-icon="arrow-down" :rules="[{ required: true, message: '请选择报关方式' }]" />
      <van-popup v-model="showDealTypeSel" position="bottom">
        <van-picker value-key="value" show-toolbar :columns="dealTypeList" @confirm="selDealType" @cancel="showDealTypeSel = false" />
      </van-popup>

      <van-field required readonly clickable name="picker" :value="supplierName" label="境外供应商名称" placeholder="点击选择供应商名称" @click="supplierSel = true" right-icon="arrow-down" :rules="[{ required: true, message: '请选择供应商名称' }]" />
      <van-popup v-model="supplierSel" position="bottom">
        <van-picker show-toolbar value-key="Name" :columns="supplierList" @confirm="selSupplier" @cancel="supplierSel = false">
          <template #title>
            <div style="text-align:center;font-size:16px;color:#ee7700" @click="()=>{ showAddSupplier=true;supplierSel=false;}">
              <van-icon name="add-o" style="font-size:18px;top:4px" />添加新供应商
            </div>
          </template>
        </van-picker>
      </van-popup>

      <van-field required readonly clickable name="picker" :value="paymentTypeName" label="外币收款方式" placeholder="点击选择外币收款方式" @click="paymentTypeSel = true" right-icon="arrow-down" :rules="[{ required: true, message: '请选择外币收款方式' }]" />
      <van-popup v-model="paymentTypeSel" position="bottom">
        <van-picker show-toolbar value-key="value" :columns="paymentTypeList" @confirm="selPaymentType" @cancel="paymentTypeSel = false" />
      </van-popup>

      <van-field v-if="this.orderInfo.PaymentType==1" required readonly clickable name="picker" :value="suplierBankName" label="外币收款账号" placeholder="点击选择外币收款账号" @click="()=>{this.orderInfo.SupplierId>0?suplierBankSel = true:suplierBankSel = false} " right-icon="arrow-down" :rules="[{ required: true, message: '请选择外币收款账号' }]" />
      <van-popup v-model="suplierBankSel" position="bottom">
        <van-picker show-toolbar value-key="BankName" :columns="suplierBankList" @confirm="selSuplierBank" @cancel="suplierBankSel = false">
          <template #title>
            <div style="text-align:center;font-size:16px;color:#ee7700" @click="()=>{ showAddSupplierBank=true;suplierBankSel=false;}">
              <van-icon name="add-o" style="font-size:18px;top:4px" />添加新供应商收款账号
            </div>
          </template>
        </van-picker>
      </van-popup>
      <van-notice-bar wrapable :scrollable="false" class="" style="border-bottom:solid 1px #ccc" v-if="orderInfo.BankId>0 && bankInfo">
        账号名称： {{bankInfo.AccountName}} <br />
        收款银行： {{bankInfo.BankName}} <br />
        银行账号： {{bankInfo.Account}} <br />
        SWIFCODE： {{bankInfo.SwiftCode}} <br />
        银行地址: {{bankInfo.Address}} <br />
      </van-notice-bar>

      <van-field label="预付供应商订金" v-if="orderInfo.PaymentType==1">
        <template #input>
          <van-radio-group v-model="isEarnest" direction="horizontal" checked-color="#ee7700">
            <van-radio :name="0">不需要</van-radio>
            <van-radio :name="1">需要</van-radio>
          </van-radio-group>
        </template>
      </van-field>

      <van-field v-if="isEarnest==1 && orderInfo.PaymentType" required v-model="orderInfo.Prepayment" label="预付定金" placeholder="请输入预付定金" />

      <van-field name="uploader" label="随货资料" style="border-bottom:none">
        <template #input>
          <div>
            <span style="font-size:12px;color:#999">请上传发票 Invoice / 装箱单 Packing List</span>
            <van-uploader :max-size="2*1024*1024" v-model="uploader" :before-delete="deletedFile" :after-read="fileUpload" upload-icon="plus" upload-text="点击上传" accept="*" />
          </div>
        </template>
      </van-field>

      <!-- 香港交货信息 -->
      <van-divider :style="{ padding: '0',height: '6px',margin: '0','border-width': '3px'}" />

      <van-cell class="item-title" title="香港交货信息" required></van-cell>
      <van-field required readonly clickable name="picker" :value="hkReceivingTypeName" label="供应商交货方式" placeholder="点击选择供应商交货方式" @click="hkReceivingTypeSel = true" right-icon="arrow-down" :rules="[{ required: true, message: '请选择供应商交货方式' }]" />
      <van-popup v-model="hkReceivingTypeSel" position="bottom">
        <van-picker show-toolbar value-key="value" :columns="hkReceivingTypeList" @confirm="selHKReceivingType" @cancel="hkReceivingTypeSel = false" />
      </van-popup>

      <van-notice-bar wrapable :scrollable="false" style="border-bottom:solid 1px #ccc;padding:8px 8px" v-if="hkReceivingTypeName=='供应商配送'">
        请让供应商将货物发到正能量的香港仓库<br />
        地址： 香港九龙观塘大业街35号福和工业大厦6楼A2室<br />
        联系人： 赵丽云 <br />
        电话： 852-35292686 <br />

        <!-- <van-button type="primary" size="mini" class="copyHkContract" @click="copyhkadressInfo()">复制</van-button> -->
        <a href="https://znlscm.com/files/templates/znl-hk-stock-v210817.pdf" class="stockInFile" target="_black">点击下载正能量香港入库要求>></a>
      </van-notice-bar>

      <div v-if="hkReceivingTypeName=='正能量代提货'">
        <van-field label="提货信息">
          <template #input>
            <van-radio-group v-model="isHasThInfo" direction="horizontal" checked-color="#ee7700">
              <van-radio :name="0">暂无信息</van-radio>
              <van-radio :name="1">已有信息</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <div v-if="isHasThInfo">
          <van-field required readonly clickable name="picker" :value="znlPickName" label="提货地址" placeholder="点击选择提货地址" @click="znlPickSel = true" right-icon="arrow-down" :rules="[{ required: true, message: '请选择提货地址' }]" />
          <van-popup v-model="znlPickSel" position="bottom">
            <van-picker show-toolbar value-key="Address" :columns="znlPickList" @confirm="selZnlPick" @cancel="znlPickSel = false">
              <template #title>
                <div style="text-align:center;font-size:16px;color:#ee7700" @click="()=>{ showAddSupplierAddress=true;znlPickSel=false;}">
                  <van-icon name="add-o" style="font-size:18px;top:4px" />添加新提货地址
                </div>
              </template>
            </van-picker>
          </van-popup>
          <van-field v-model="orderInfo.ExtraInfo.Pickup.Weight" label="重量（KG）" placeholder="请输入重量" />
          <van-field v-model="orderInfo.ExtraInfo.Pickup.Boxes" label="箱数（箱）" placeholder="请输入箱数" />
          <van-field v-model="orderInfo.ExtraInfo.Pickup.Other" label="其他" placeholder="如：体积、卡板数" />
          <van-field v-model="orderInfo.ExtraInfo.Pickup.Remark" label="提货要求" placeholder="如：提货时间、是否携带公章等" />
        </div>
      </div>

      <div v-if="hkReceivingTypeName=='快递'">
        <van-field label="快递类型">
          <template #input>
            <van-radio-group v-model="orderInfo.IsClearCustoms" direction="horizontal" checked-color="#ee7700">
              <van-radio :name="0">香港本地</van-radio>
              <van-radio :name="1">非香港本地</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field v-model="orderInfo.HKReceivingExpressName" label="快递公司" placeholder="请输入快递公司" />

        <van-field v-model="orderInfo.ReimbursedExpenses" label="快递费到付">
          <template #input>
            <van-radio-group v-model="isHasThInfo" direction="horizontal" checked-color="#ee7700">
              <van-radio :name="0">否</van-radio>
              <van-radio :name="1">是</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field v-model="orderInfo.HKReceivingExpressNo" label="快递单号" placeholder="多个快递单号，请以逗号隔开" />
      </div>

      <van-field v-model="orderInfo.TallyRequirements" label="理货要求" placeholder="请输入理货要求" style="border-bottom:none" />

      <!-- 国内物流信息 -->
      <van-divider :style="{ padding: '0',height: '6px',margin: '0','border-width': '3px'}" />

      <van-cell class="item-title" title="国内物流信息" required></van-cell>
      <van-field required readonly clickable name="picker" :value="stockOutTypeName" label="国内交货方式" placeholder="点击选择国内交货方式" @click="stockOutTypeSel = true" right-icon="arrow-down" :rules="[{ required: true, message: '请选择国内交货方式' }]" />
      <van-popup v-model="stockOutTypeSel" position="bottom">
        <van-picker show-toolbar value-key="value" :columns="stockOutTypeList" @confirm="selstockOutType" @cancel="stockOutTypeSel = false" />
      </van-popup>

      <div v-if="stockOutTypeName=='正能量送货' || stockOutTypeName=='快递'">
        <van-field required readonly clickable name="picker" :value="znlDeliverName" label="收货地址" placeholder="点击选择收货地址" @click="znlDeliverSel = true" right-icon="arrow-down" :rules="[{ required: true, message: '请选择收货地址' }]" />
        <van-popup v-model="znlDeliverSel" position="bottom">
          <van-picker show-toolbar value-key="FullAddress" :columns="znlDeliverList" @confirm="selZnlDeliver" @cancel="znlDeliverSel = false">
            <template #title>
              <div style="text-align:center;font-size:16px;color:#ee7700" @click="()=>{ showAddAddress=true;znlPickSel=false;}">
                <van-icon name="add-o" style="font-size:18px;top:4px" />添加新送货地址
              </div>
            </template>
          </van-picker>
        </van-popup>
      </div>

      <div v-if="stockOutTypeName=='快递'">
        <van-field required v-model="orderInfo.DeliveryExpressCompany" label="快递公司" placeholder="请输入快递公司" :rules="[{ required: true, message: '请输入快递公司' }]" />
        <van-field required v-model="orderInfo.DeliveryCostType" label="快递费" class="rBgColor" :rules="[{ required: true, message: '请选择快递费方式' }]">
          <template #input>
            <van-radio-group v-model="isHasThInfo" direction="horizontal" checked-color="#ee7700">
              <van-radio :name="0">到付</van-radio>
              <van-radio :name="1">垫付</van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </div>

      <div v-if="stockOutTypeName=='自提'">
        <van-field required v-model="orderInfo.ShippingContact" label="提货人" placeholder="请输入提货人姓名" :rules="[{ required: true, message: '请输入提货人姓名' }]" />
        <van-field required v-model="orderInfo.ShippingMobile" label="提货人电话" placeholder="请输入提货人电话" :rules="[{ required: true, message: '请输入提货人电话' }]" />
        <van-field required v-model="orderInfo.ShippingCode" label="身份证" placeholder="请输入提货人身份证" :rules="[{ required: true, message: '请输入提货人身份证' }]" />
      </div>

      <van-field v-model="orderInfo.Remark" label="订单备注" placeholder="请输入订单备注" />

      <add-supplier :show="showAddSupplier" @supplierCb="supplierCb"></add-supplier>
      <add-supplier-bank :show="showAddSupplierBank" @supplierBankCb="supplierBankCb" :SupplierId="this.orderInfo.SupplierId" :SupplierName="this.orderInfo.SupplierName"></add-supplier-bank>

      <add-supplier-address :show="showAddSupplierAddress" @supplierAddressCb="supplierAddressCb" :SupplierId="this.orderInfo.SupplierId" :SupplierName="this.orderInfo.SupplierName"></add-supplier-address>

      <add-delivery-address :show="showAddAddress" @addressCb="addressCb" :selectType="1"></add-delivery-address>

      <div style="height:84px;padding:20px 10px;display:flex;justify-content: space-between;">
        <van-button size="normal" type="default" style="width:160px" @click="()=> {this.$router.back()}">取消</van-button>
        <van-button size="normal" type="info" style="background-color:#EE7700;border:none;width:160px" native-type="submit">保存并提交</van-button>
      </div>

    </van-form>

  </div>
</template>

<script>
import {
  getReservedNo,
  getCurContract,
  AddOrder,
  getOrderDetail,
  EditOrder,
} from "~/api/order";
import { getExcelData } from "~/script/utils";
import { getSuppliers, getSupplierAddressById } from "~/api/supplier";
import { getSupplierBanks } from "~/api/supplierBank";
import { getShippingAddressList } from "~/api/szDelivery";

import addSupplier from "../Supplier/AddView.vue";
import addSupplierBank from "../Supplier/bank/AddBankView.vue";
import addSupplierAddress from "../Supplier/Address/AddAddressView.vue";
import addDeliveryAddress from "../UserCenter/ReceiverAddress/AddView.vue";
import { getSession, uploadFile, deletedFile } from "~/api/upload";

const FileTypePackaging = "agent_order_packaging";

export default {
  name: "orderListView",
  components: {
    addSupplier,
    addSupplierBank,
    addSupplierAddress,
    addDeliveryAddress,
  },
  data() {
    return {
      isEdit: false,
      isTabsShow: true,
      isSearchShow: true,
      tabList: [
        { title: "报关产品信息" },
        { title: "香港交货信息" },
        { title: "国内物流信息" },
      ],
      tabType: 0,
      active: 0,

      dealTypeName: "",
      showDealTypeSel: false,
      dealTypeList: [],

      paymentTypeName: "",
      paymentTypeList: [
        { key: 1, value: "T/T 电汇" },
        { key: 3, value: "暂不付货款" },
        { key: 4, value: "其他" },
      ],
      paymentTypeSel: false,

      suplierBankName: "",
      suplierBankList: [],
      suplierBankSel: false,

      supplierName: "",
      supplierList: [],
      supplierSel: false,

      reservedName: "",
      reservedList: [],
      reservedSel: false,

      hkReceivingTypeName: "",
      hkReceivingTypeList: [
        { key: 1, value: "供应商配送" },
        { key: 2, value: "正能量代提货" },
        { key: 3, value: "快递" },
      ],
      hkReceivingTypeSel: false,

      stockOutTypeName: "",
      stockOutTypeList: [
        { key: 1, value: "正能量送货" },
        { key: 4, value: "快递" },
        { key: 2, value: "自提" },
        { key: 3, value: "待确认" },
      ],
      stockOutTypeSel: false,

      znlPickName: "",
      znlPickList: [],
      znlPickSel: false,

      znlDeliverName: "",
      znlDeliverList: [],
      znlDeliverSel: false,

      currencyTypeList: ["USD", "HKD"],
      currencyTypeSel: false,

      uploader: [],
      orderInfo: {
        Id: undefined,
        Code: undefined,
        LineList: [],
        CurrencyType: null,
        SupplierName: undefined,
        SupplierId: 0,
        ExpectedArrivalAt: undefined,
        DealType: null,
        SupplierContact: undefined,
        SupplierPhone: undefined,
        SupplierEmail: undefined,
        HKReceivingType: undefined,
        HKReceivingRecipientId: undefined,
        HKReceivingContact: undefined,
        HKReceivingMobile: undefined,
        HKReceivingAddress: undefined,
        Remark: undefined,
        PurchaseOrderGuid: null,
        StkInGuid: null,
        DataSources: undefined,
        Status: 0,
        StockOutType: undefined,
        DeliveryRemark: undefined,
        InvoiceRemark: undefined,

        ShippingId: undefined,
        ShippingCompanyName: undefined,
        ShippingContact: undefined,
        ShippingFullAddress: undefined,
        ShippingMobile: undefined,

        // 银行信息
        PaymentType: undefined,
        BankId: 0,

        ClientSalesmanId: 0, // 业务联系人
        ReservationId: undefined,

        IsClearCustoms: undefined,
        PickupGoodsTime: undefined,
        PickupGoodsRemark: undefined,

        HKReceivingExpressName: undefined,
        HKReceivingExpressNo: undefined,
        ReimbursedExpenses: false,
        TallyRequirements: undefined,
        ShippingCode: undefined,

        DeliveryExpressCompany: undefined,
        DeliveryStatus: undefined,
        DeliveryStatusStr: undefined,
        DeliveryCostType: 0,
        Prepayment: undefined,
        TaxAgentMonthly: 0,
        ExpectTaxAgentFee: 0,
        TaxAgentPayType: 0,
        UploadSessionId: undefined,
        ReservationNumberId: undefined,
        ExtraInfo: {
          Pickup: {
            Weight: undefined,
            Boxes: undefined,
            Other: undefined,
            Remark: undefined,
          },
        },
      },
      lineDetail: {
        ProductName: undefined,
        PartNo: undefined,
        Brand: undefined,
        Unit: "个",
        Quantity: undefined,
        UnitPrice: undefined,
        Amount: undefined,
        Weight: undefined,
        NetWeight: undefined,
        ErpOriginRegion: undefined,
        ClientPartNo: undefined,
        ClientOrderNo: undefined,
      },
      TotalAmount: 0,
      show: false,
      showPaste: false,
      isHasThInfo: 1,
      isEarnest: 0,
      pasteText: undefined,
      editIndex: -1,
      showAddSupplier: false,
      showAddSupplierBank: false,
      showAddSupplierAddress: false,
      showAddAddress: false,
      bankInfo: null,
    };
  },

  methods: {
    changeTab(type) {
      this.tabType = type;
    },
    selDealType(obj) {
      this.dealTypeName = obj.value;
      this.orderInfo.DealType = obj.key;
      this.showDealTypeSel = false;
    },
    selPaymentType(obj) {
      this.paymentTypeName = obj.value;
      this.orderInfo.PaymentType = obj.key;
      this.paymentTypeSel = false;
    },
    selSupplier(obj) {
      this.supplierName = obj.Name;
      this.orderInfo.SupplierId = obj.Id;
      this.orderInfo.SupplierName = obj.Name;
      this.supplierSel = false;
      this.setSupplierBanks(this.orderInfo.SupplierId);
      this.setSupplierAddress(this.orderInfo.SupplierId);
    },
    selReserved(value) {
      this.reservedName = value.OrderNo;
      this.orderInfo.ReservationId = value.Id;
      this.reservedSel = false;
    },
    selHKReceivingType(obj) {
      this.hkReceivingTypeName = obj.value;
      this.orderInfo.HKReceivingType = obj.key;
      this.hkReceivingTypeSel = false;
      if (obj.key == 2) {
        this.setSupplierAddress(this.orderInfo.SupplierId);
      }
    },
    selstockOutType(obj) {
      this.stockOutTypeName = obj.value;
      this.orderInfo.StockOutType = obj.key;
      this.stockOutTypeSel = false;
      if (obj.key == 1) {
        this.setDeliveryAddress();
      }
    },
    selcurrencyType(value) {
      this.orderInfo.CurrencyType = value;
      this.currencyTypeSel = false;
    },

    selSuplierBank(obj) {
      this.orderInfo.BankId = obj.Id;
      this.suplierBankSel = false;
      this.bankInfo = obj;
      this.suplierBankName = obj.BankName;
    },

    selZnlPick(obj) {
      this.znlPickSel = false;
      this.orderInfo.HKReceivingRecipientId = obj.Id;
      this.znlPickName = obj.Address;
    },

    selZnlDeliver(obj) {
      this.znlDeliverSel = false;
      this.orderInfo.ShippingId = obj.Id;
      this.orderInfo.ShippingCompanyName = obj.CompanyName;
      this.orderInfo.ShippingContact = obj.Name;
      this.orderInfo.ShippingMobile = obj.Mobile;
      this.orderInfo.ShippingFullAddress = obj.FullAddress;
      this.znlDeliverName = `${obj.FullAddress}-${obj.Name}-${obj.Mobile}`;
    },

    copyhkadressInfo() {},

    pasteProductInfo() {
      const data = this.pasteText;
      if (!data || data.length < 10) {
        Toast.fail("请先录入有效数据");
        return;
      }

      let header =
        "品名\t品牌\t型号\t产地\t数量\t单位\t单价\t净重\t毛重\t料号\t编号\n";
      if (data.indexOf("型号") != -1) {
        header = "";
      }

      const dataMap = {
        品牌: "Brand",
        品名: "ProductName",
        型号: "PartNo",
        产地: "ErpOriginRegion",
        数量: "Quantity",
        单位: "Unit",
        单价: "UnitPrice",
        总金额: "Amount",
      };

      const newData = getExcelData(header + data, dataMap, "Order");

      if (newData == null) return;

      this.addProductLine(lines);
      this.pasteText = undefined;
    },

    addProductLine(data) {
      let lines = this.orderInfo.LineList;

      if (this.editIndex >= 0) {
        lines[this.editIndex] = data[0];
        this.editIndex = -1;
      } else {
        data.forEach((x) => {
          lines.push(x);
        });
      }

      this.TotalAmount = 0;
      lines.forEach((x) => {
        this.TotalAmount += Number(x.Amount);
      });

      this.orderInfo.LineList = lines;
      this.show = false;
    },

    saveCurLineDetail() {
      let line = {};
      Object.keys(this.lineDetail).forEach((key) => {
        line[key] = this.lineDetail[key];
        if (key == "Unit") {
          this.lineDetail[key] = "个";
        } else {
          this.lineDetail[key] = undefined;
        }
      });
      this.addProductLine([line]);
    },

    amountChange() {
      let line = this.lineDetail;
      if (line.Quantity) {
        this.lineDetail.UnitPrice = (
          Number(line.Amount) / Number(line.Quantity)
        ).toFixed(8);
      }
    },
    unitPriceChange() {
      let line = this.lineDetail;
      if (line.Quantity) {
        this.lineDetail.Amount = (
          Number(line.Quantity) * Number(line.UnitPrice)
        ).toFixed(2);
      }
    },

    editProdctItem(index) {
      this.show = true;
      this.editIndex = index;
      this.lineDetail = this.orderInfo.LineList[index];
    },

    delProductItem(index) {
      let lines = [];
      let totalAmount = 0;
      this.orderInfo.LineList.forEach((v, i) => {
        if (i == index) return;
        lines.push(v);
        totalAmount += Number(v.Amount);
      });

      this.orderInfo.LineList = lines;
      this.TotalAmount = totalAmount;
    },

    hideLineDetailEdit() {
      this.$refs.lineDetailForm.resetValidation("");
      this.show = false;
    },

    async init() {
      this.setReservedNos();
      this.setDealTypes();
      this.setSuppliers();
      let res = await getSession();
      this.orderInfo.UploadSessionId = res.SessionId;

      let id = this.$route.query["id"];
      if (id) {
        let orderInfo = await getOrderDetail({ Id: id });
        if (!orderInfo) return;

        this.isEdit = true;
        this.orderInfo = orderInfo;

        let selDealType;
        this.dealTypeList.map((x) => {
          if (x.key == orderInfo.DealType) {
            selDealType = x;
          }
        });
        if (selDealType) this.selDealType(selDealType);
        if (orderInfo.ReservationNumberId > 0) {
          this.reservedName = orderInfo.Code;
          this.orderInfo.ReservationId = orderInfo.ReservationNumberId;
        }

        this.selSupplier({
          Name: orderInfo.SupplierName,
          Id: orderInfo.SupplierId,
        });
        let payMentValue = "";
        this.paymentTypeList.map((x) => {
          if (x.key == orderInfo.PaymentType) payMentValue = x.value;
        });
        this.selPaymentType({
          key: orderInfo.PaymentType,
          value: payMentValue,
        });
        this.selSuplierBank({
          Id: orderInfo.BankId,
          BankName: orderInfo.BankName,
        });

        let hkReceName = "";
        this.hkReceivingTypeList.map((x) => {
          if (x.key == orderInfo.HKReceivingType) hkReceName = x.value;
        });
        this.selHKReceivingType({
          key: orderInfo.HKReceivingType,
          value: hkReceName,
        });

        let stockOutName = "";
        this.stockOutTypeList.map((x) => {
          if (x.key == orderInfo.StockOutType) stockOutName = x.value;
        });
        this.selstockOutType({
          key: orderInfo.StockOutType,
          value: stockOutName,
        });

        this.znlDeliverName = `${orderInfo.ShippingFullAddress}-${orderInfo.ShippingContact}-${orderInfo.ShippingMobile}`;
      }
    },

    async setReservedNos() {
      let reservedNos = await getReservedNo({ OrderType: 1 });
      reservedNos.unshift({ OrderNo: "", Id: null });
      this.reservedList = reservedNos;
    },

    async setDealTypes() {
      let data = await getCurContract();
      var mask = 0x10;
      var types = [];
      for (var i = 0; i < 4; i++) {
        mask >>= 1;
        var t = data.DealType & mask;
        if (!t) continue;
        types.push(t);
      }
      if (this.orderInfo.Id) {
        if (
          this.orderInfo.DealType &&
          !(data.DealType & this.orderInfo.DealType)
        )
          types.push(this.orderInfo.DealType); //如果原协议已经过来，追加原协议
      }
      types.reverse();

      let curDealTypeList = [];
      types.forEach((x) => {
        let option = {};
        if (x == 1) {
          option = { key: x, value: "双抬头" };
        } else if (x == 2) {
          option = { key: x, value: "单抬头" };
        } else if (x == 4) {
          option = { key: x, value: "纯代理" };
        } else {
          option = { key: x, value: "清关服务" };
        }
        curDealTypeList.push(option);
      });

      this.dealTypeList = curDealTypeList;
    },

    async setSuppliers() {
      let data = await getSuppliers();
      this.supplierList = data;
    },

    async setSupplierBanks(Id) {
      let data = await getSupplierBanks({ SupplierId: Id });
      this.suplierBankList = data;
    },

    async setSupplierAddress(Id) {
      let data = await getSupplierAddressById({ SupplierId: Id });
      this.znlPickList = data;
    },

    async setDeliveryAddress() {
      let data = await getShippingAddressList();
      let newData = [];
      data.forEach((item) => {
        if (item.Type === 1 && !item.IsDisable) {
          newData.push(item);
        }
      });
      this.znlDeliverList = newData;
    },

    supplierCb(data) {
      this.showAddSupplier = false;
      if (data) {
        this.orderInfo.SupplierId = data.SupplierId;
        this.orderInfo.SupplierName = data.SupplierName;
        this.supplierSel = false;
        this.setSuppliers();
        this.setSupplierBanks(this.orderInfo.SupplierId);
        this.supplierName = data.SupplierName;
      }
    },

    supplierBankCb(data) {
      this.showAddSupplierBank = false;
      if (data) {
        this.orderInfo.BankId = data.BankId;
        this.setSupplierBanks(this.orderInfo.SupplierId);
        this.bankInfo = data.BankInfo;
        this.suplierBankName = data.BankInfo.BankName;
      }
    },

    supplierAddressCb(data) {
      this.showAddSupplierAddress = false;
      if (data) {
        this.setSupplierAddress(this.orderInfo.SupplierId);
        this.orderInfo.HKReceivingRecipientId = data.AddressId;
        this.znlPickName = data.AddressName;
      }
    },

    addressCb(data) {
      this.showAddAddress = false;
      if (data) {
        this.setDeliveryAddress();
        this.orderInfo.ShippingId = data.ShippingId;
        this.orderInfo.ShippingCompanyName = data.CompanyName;
        this.orderInfo.ShippingContact = data.Name;
        this.orderInfo.ShippingMobile = data.Mobile;
        this.orderInfo.ShippingFullAddress = data.FullAddress;
        this.znlDeliverName = `${data.FullAddress}-${data.Name}-${data.Mobile}`;
      }
    },

    async fileUpload(file) {
      let url = "";
      if (this.orderInfo.Id)
        url = `api/Upload/Post?type=${FileTypePackaging}&relationId=${this.orderInfo.Id}`;
      else
        url = `api/Upload/Post?type=${FileTypePackaging}&sessionId=${this.orderInfo.UploadSessionId}`;
      var data = new FormData();
      data.append("file", file.file);

      try {
        const res = await uploadFile(url, data);
        this.uploader[this.uploader.length - 1].Id = res.Id;
      } catch {
        this.uploader.pop();
        this.$toast.fail("上传失败，请重试！");
      }
    },

    async deletedFile(file, detail) {
      let index = detail.index;
      let id = this.uploader[index].Id;
      if (id) {
        try {
          await deletedFile({ Id: id });
        } catch {
          this.$toast.fail("删除失败，请重试！");
          return false;
        }
      }

      return true;
    },

    async saveOrder() {
      if (!this.orderInfo.LineList || this.orderInfo.LineList.length == 0) {
        this.$toast.fail("请填写报关商品！");
        return;
      }
      let loading = this.$toast.loading({
        message: "正在保存...",
        forbidClick: true,
        duration: 0,
      });
      try {
        let res = null;
        if (this.isEdit) {
          res = await EditOrder(this.orderInfo);
        } else {
          res = await AddOrder(this.orderInfo);
        }

        this.$router.push({
          name: "orderDetail",
          query: {
            id: res.Id,
          },
        });
        loading.clear();
      } catch (e) {       
        loading.clear();
        this.$toast.fail(e);
      }
    },
  },

  watch: {
    "lineDetail.Quantity": {
      immediate: true,
      handler(v) {
        let line = this.lineDetail;
        if (line.UnitPrice) {
          this.lineDetail.Amount = (
            Number(line.Quantity) * Number(line.UnitPrice)
          ).toFixed(2);
        } else if (line.Amount) {
          this.lineDetail.UnitPrice = (
            Number(line.Amount) / Number(line.Quantity)
          ).toFixed(8);
        }
      },
    },
    "lineDetail.PartNo": {
      immediate: true,
      handler(v) {
        if(this.lineDetail.PartNo){
          this.lineDetail.PartNo=this.lineDetail.PartNo.toUpperCase();
        }
      },
    },
    "lineDetail.Brand": {
      immediate: true,
      handler(v) {
        if(this.lineDetail.Brand){
          this.lineDetail.Brand=this.lineDetail.Brand.toUpperCase();
        }
      },
    },
  },

  created() {
    this.init();
  },
};
</script>

<style lang="less" scope>
.van-cell {
  border-bottom: 1px solid #ccc;
  color: #000;
}
.item-title .van-cell__title {
  position: relative !important;
}

.item-title .van-cell__title::before {
  content: "";
  position: absolute;
  width: 5px;
  height: 100%;
  background-color: #ee7700;
  left: -15px;
}

.van-tabs__line {
  background-color: #ee7700 !important;
  z-index: 0;
}

.van-cell::after {
  display: none;
}

.van-field__label {
  width: 110px;
}

.van-overlay {
  background-color: #000 !important;
  opacity: 0.7;
}

.van-cell--required .van-field__body {
  background: #fbffd5;
}

.rBgColor .van-field__body {
  background-color: #fff !important;
  z-index: 0;
}

.van-notice-bar__content {
  width: 100%;
}

.copyHkContract {
  position: absolute;
  top: 0;
  right: 0;
}

.stockInFile {
  position: absolute;
  bottom: 0;
  right: 0;
}

.custom-image {
  padding-bottom: 0;
  padding-top: 10px;
}

.custom-image .van-empty__image {
  width: 50px;
  height: 50px;
}

.van-field--error .van-field__control,
.van-field--error .van-field__control::placeholder {
  color: #ccc !important;
}
</style>
